import React from "react";
import { Link } from "react-router-dom";

import GameDialogForm from "./Form";
import GameLinks from "../Links";
import AppNoticeModal from "../../NoticeModal";

import "./Dialog.scss";

function GameDialog() {
  
  return (
    <div className="game-dialog">
      <header>
        <h1>BLACKBOX</h1>
        <h2>The ultimate game of hide and seek</h2>
      </header>

      <p className="centered">
        See the <Link to="/colophon">colophon</Link> for what's new in this version.
      </p>

      <p className="verbose">
        This implementation of BlackBox™ is an online, single-player version of the popular Parker Brothers
        game BlackBox™ board game. The purpose of the game is to use deductive reasoning to determine the
        location of 3 to 5 unseen "balls" placed within an 8-by-8 grid.
      </p>

      <p className="verbose">
        The player shoots virtual "rays" into the grid, and observes their behavior. Since the behavior of the
        rays when encountering the balls within the grid are based upon a deterministic set of simple rules,
        the player can use the externally-observed behavior to deduce the location of the balls.
      </p>

      <p className="verbose">
        Descriptions of these ray behavior rules can be found by clicking on the Player's Guide link below, or
        from a similar link on the game board during play.
      </p>

      <GameDialogForm />

      <GameLinks />

      <AppNoticeModal />
    </div>
  );
}

export default GameDialog;
